export const HOME_PAGE_ROUTER_PATH = '/';

export const NOT_FOUND_PAGE_ROUTER_PATH = '/404/';

export const RESUME_LANDING_ROUTER_PATH = '/jianli/';

export const PUBLIC_PROFILE_ROUTER_PATH = '/public-profile/[id]';

export const PUBLIC_PROFILE_SETTING_ROUTER_PATH = '/public-profile/setting';

export const PUBLIC_JOB_ROUTER_PATH = '/jobs/[id]';

export const PUBLIC_JOB_PAGE_ROUTER_PATH = '/jobs/';

export const JOB_TITLE_ROUTER_PATH = '/job-titles/[id]';

export const JOB_TITLE_PAGE_ROUTER_PATH = '/job-titles/';

export const JOB_DETAIL_PAGE_ROUTER_PATH = '/job-detail/';

export const JOB_RANKING_PAGE_ROUTER_PATH = '/rank/';

export const EMPLOYER_CANDIDATES_ROUTER_PATH = '/employer/candidates/';

export const EMPLOYER_COMPANY_ROUTER_PATH = '/employer/company/';

export const EMPLOYER_JOBS_ROUTER_PATH = '/employer/jobs/';

export const EMPLOYER_JOBS_CANDIDATES_ROUTER_PATH =
  '/employer/jobs/[id]/candidates';

export const EMPLOYER_JOBS_CANDIDATES_REPORT_ROUTER_PATH =
  '/employer/jobs/[id]/candidates/[flowId]';

export const EMPLOYER_JOB_POST_ROUTER_PATH = '/employer/jobs/job-post';

export const EMPLOYER_JOB_EDIT_ROUTER_PATH = '/employer/jobs/job-post/[id]';

export const EMPLOYER_JOB_EDIT_PAGE_ROUTER_PATH = '/employer/jobs/job-post/';

export const EMPLOYER_REGISTER_ROUTER_PATH = '/employer/register/';

export const EMPLOYER_LANDING_ROUTER_PATH = '/employer/';

export const CULTURAL_ROUTER_PATH = '/wenhua/';

export const CULTURAL_ALL_TYPE_ROUTER_PATH = '/wenhua/result/all';

export const CULTURAL_QUIZ_ROUTER_PATH = '/wenhua/quiz/';

export const CULTURAL_CHECK_ROUTER_PATH = '/wenhua/check';

export const CULTURAL_RESULT_ROUTER_PATH = '/wenhua/result/';

export const PUBLIC_COMPANY_ROUTER_PATH = '/companies/[id]';

export const COMPANY_ROUTER_PATH = '/companies/';

export const CANDIDATES_ME_ROUTER_PATH = '/jianli/me/';

export const DEFAULT_CANDIDATES_ME_ROUTER_PATH = '/jianli/me/default/';

export const RESUME_CONSULTATION_ROUTER_PATH = '/jianli/service/';

export const RESUME_CONSULTATION_ORDER_ROUTER_PATH = '/jianli/service-order/';

export const RESUME_EVALUATION_ROUTER_PATH = '/jianli/evaluation/';

export const RESUME_EVALUATION_LOADING_ROUTER_PATH =
  '/jianli/evaluation/loading/';

export const RESUME_EVALUATION_ME_ROUTER_PATH = '/jianli/evaluation/me/';

export const CANDIDATES_ME_UPLOAD_RESUME_ROUTER_PATH =
  '/jianli/me/upload_resume/';

export const JOB_SALARY_INSIGHT_ROUTER_PATH = '/job-salary-insight/';

export const JOBS_MATCHED_ROUTER_PATH = '/jobs/matched';

export const JOBS_MATCHED_DETAIL_ROUTER_PATH = '/jobs/matched/[id]';

export const WELCOME_ROUTER_PATH = '/welcome';

export const ARTICLES_ROUTER_PATH = '/articles/';

export const TERMS_ROUTER_PATH = '/terms/';

export const PRIVACY_ROUTER_PATH = '/privacy/';

export const LOGIN_ROUTER_PATH = '/login/';

export const SITEMAP_ROUTER_PATH = '/sitemap/';

export const SUBSCRIBE_ROUTER_PATH = '/subscribe/';

export const INTERVIEW_CONTACT_US_ROUTER_PATH = '/interview-contact-us';

export const RECORD_URL = 'https://beian.miit.gov.cn/';

export const PRODUCTION_URL = 'https://www.tanzhi.cn';
export const PRODUCTION_HOST = 'www.tanzhi.cn';

export const PRODUCTION_ENVIRONMENT = 'production';
